(function () {
  'use strict';

  function initSection(section) {
    if (section.dataset.customFishlabInitialized) return;
    section.dataset.customFishlabInitialized = 'true';

    const tabs = Array.from(section.querySelectorAll('[data-fishlab-tab]'));
    const panels = Array.from(section.querySelectorAll('[data-fishlab-panel]'));
    if (tabs.length === 0 || panels.length === 0) return;

    function getActiveSlideshow() {
      const activePanel = panels.find((p) => p.classList.contains('is-active'));
      return activePanel ? activePanel.querySelector('slideshow-component') : null;
    }

    function activate(target, opts) {
      const focus = opts && opts.focus;
      tabs.forEach((t) => {
        const active = t.getAttribute('data-fishlab-tab') === target;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.setAttribute('tabindex', active ? '0' : '-1');
        if (focus && active) t.focus();
      });
      panels.forEach((p) => {
        const active = p.getAttribute('data-fishlab-panel') === target;
        p.classList.toggle('is-active', active);
        if (active) {
          p.removeAttribute('hidden');
        } else {
          p.setAttribute('hidden', '');
        }
      });
    }

    const navPrev = section.querySelector('[data-fishlab-nav-prev]');
    const navNext = section.querySelector('[data-fishlab-nav-next]');
    if (navPrev) navPrev.addEventListener('click', () => { const ss = getActiveSlideshow(); if (ss && typeof ss.previous === 'function') ss.previous(); });
    if (navNext) navNext.addEventListener('click', () => { const ss = getActiveSlideshow(); if (ss && typeof ss.next === 'function') ss.next(); });

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => {
        activate(tab.getAttribute('data-fishlab-tab'));
      });
      tab.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          const dir = e.key === 'ArrowRight' ? 1 : -1;
          const next = tabs[(i + dir + tabs.length) % tabs.length];
          activate(next.getAttribute('data-fishlab-tab'), { focus: true });
        } else if (e.key === 'Home') {
          e.preventDefault();
          activate(tabs[0].getAttribute('data-fishlab-tab'), { focus: true });
        } else if (e.key === 'End') {
          e.preventDefault();
          activate(tabs[tabs.length - 1].getAttribute('data-fishlab-tab'), { focus: true });
        }
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-custom-fishlab]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
